import React from 'react';
import './style.css';

export const NONE = 'NONE';
export const PARTIAL = 'PARTIAL';
export const ALL = 'ALL';

export type TriStateCheckboxState = typeof NONE | typeof PARTIAL | typeof ALL;

interface IProps {
  state: TriStateCheckboxState;
  onChange: (e: any) => void;
  disabled?: boolean;
}

const TriStateCheckbox: React.FC<IProps> = ({ state, onChange, disabled }) => {
  return (
    <span
      data-checked={state}
      data-disabled={disabled ? 'true' : 'false'}
      onClick={onChange}
      onKeyDown={(e) => e.key === 'Enter' && onChange(e)}
      className={'tri-state-checkbox'}
    />
  );
};

export default TriStateCheckbox;
